import { useState } from 'react';
import { useQuery } from "@tanstack/react-query";

const WorldMapPage = ({ setPageIndex, passport, explore, setExplore }) => {
	const API_URL = import.meta.env.VITE_API_URL;
	const [exploreStatus, setExploreStatus] = useState("all");

	const { data } = useQuery({
		queryKey: ['explore_list', passport?.id, explore?.level],
		queryFn: async () => {
			const params = new URLSearchParams();
			params.append("passportId", passport?.id);
			params.append("exploreLevel", explore?.level);

			const response = await fetch(`${API_URL}/bbs/ajax.get_explore_list.php`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: params,
				credentials: 'include'
			});
			if (!response.ok) throw new Error("네트워크 오류");

  	  		return response.json();
		},
		enabled: !!passport?.id,
	});
	
	const items = data?.data?.list ?? null;
	const filteredItems = items?.filter((item) => {
		if (exploreStatus === "all") return true;
		if (exploreStatus === "done") return item.isDone;
		if (exploreStatus === "not_done") return !item.isDone;
		return true;
	});

	const missions = {
        IMG : {1:'🎨',2:'🖼️',3:'🎭', position : { top: '25%', left: '18%' }},
        VID : {1:'🎬',2:'🎥',3:'📹', position : { top: '18%', left: '50%' }},
        STY : {1:'📖',2:'📚',3:'📜', position : { top: '25%', left: '82%' }},
        MUS : {1:'🎵',2:'🎼',3:'🎹', position : { top: '55%', left: '25%' }},
        WRT : {1:'✍️',2:'🖊️',3:'✒️',  position : { top: '55%', left: '75%' }},
        MTH : {1:'🔢',2:'➗',3:'∑',  position : { top: '85%', left: '30%' }},
        WND : {1:'🔬',2:'🧪',3:'⚗️', position : { top: '85%', left: '70%' }},
    };

	const handleClick = (exploreCode, exploreLevel) => {
		setPageIndex(3);
		setExplore({code: exploreCode, level: exploreLevel});
	}

  	return (
		<div className="p-[30px] px-5 py-12 pb-24 md:px-8 md:py-16 md:pb-28 md:px-10 md:py-20 md:pb-32 bg-none md:bg-gradient-to-b md:from-blue-100 md:via-sky-100 md:to-green-100">
			<h2 className="text-3xl font-bold text-center mb-4 text-white md:text-blue-900">🗺️ AI 탐험 세계지도</h2>
			<p className="text-center text-sm mb-6 text-white md:text-gray-600">7개의 신비로운 나라를 탐험하세요!</p>
			<div className="md:hidden space-y-4">
				<div className="bg-white/95 p-4 rounded-[14px] border-2 border-blue-800 shadow-md backdrop-blur">
					<div className="flex justify-between text-sm mb-2">
						<div>
							<span className="text-slate-500">레벨: </span>
							<span className="font-bold text-blue-600">{explore?.level}</span>
						</div>
						<div>
							<span className="text-slate-500">완료: </span>
							<span className="font-bold text-green-500">
								{items?.filter(item => item.isDone).length}
							</span>
							<span className="text-slate-400">
								{" / "}{data?.data?.pagination?.total_count}
							</span>
						</div>
					</div>
					<div className="flex gap-3 text-[11px]">
						<label className="flex items-center gap-1 cursor-pointer">
							<input
								type="radio"
								name="exploreStatus"
								value="all"
								checked={exploreStatus === "all"}
								onChange={() => setExploreStatus("all")}
								className="hidden"
							/>
							<div
								className={`w-4 h-4 border-2 rounded flex items-center justify-center text-[10px]
								${
									exploreStatus === "all"
									? "bg-gradient-to-br from-yellow-100 to-yellow-400 border-yellow-500"
									: "bg-white border-slate-400"
								}`}
							>
								{exploreStatus === "all" && "✓"}
							</div>
							<span>전체</span>
						</label>
						<label className="flex items-center gap-1 cursor-pointer">
							<input
								type="radio"
								name="exploreStatus"
								value="not_done"
								checked={exploreStatus === "not_done"}
								onChange={() => setExploreStatus("not_done")}
								className="hidden"
							/>
							<div
								className={`w-4 h-4 border-2 rounded flex items-center justify-center text-[10px]
								${
									exploreStatus === "not_done"
									? "bg-gradient-to-br from-yellow-100 to-yellow-400 border-yellow-500"
									: "bg-white border-slate-400"
								}`}
							>
								{exploreStatus === "not_done" && "✓"}
							</div>
							<span>미탐험</span>
						</label>

						<label className="flex items-center gap-1 cursor-pointer">
							<input
								type="radio"
								name="exploreStatus"
								value="done"
								checked={exploreStatus === "done"}
								onChange={() => setExploreStatus("done")}
								className="hidden"
							/>
							<div
								className={`w-4 h-4 border-2 rounded flex items-center justify-center text-[10px]
								${
									exploreStatus === "done"
									? "bg-gradient-to-br from-yellow-100 to-yellow-400 border-yellow-500"
									: "bg-white border-slate-400"
								}`}
							>
								{exploreStatus === "done" && "✓"}
							</div>
							<span>탐험완료</span>
						</label>
					</div>
				</div>
				<div className="space-y-3">
					{!filteredItems || filteredItems.length === 0 ? (
						<div className="flex flex-col items-center justify-center py-10 px-6 bg-white border-2 border-dashed border-slate-300 rounded-[16px] shadow-sm">
							<div className="text-lg font-bold text-slate-700 mb-1">
								탐험할 나라가 없어요
							</div>
							<div className="text-sm text-slate-400">
								다른 조건으로 다시 찾아보세요
							</div>
						</div>
						) : (
						filteredItems.map((item) => (
							<div
								key={item.id}
								onClick={() => handleClick(item.code, item.level)}
								className={`flex items-center justify-between p-3 rounded-[12px] border-2 shadow-sm cursor-pointer transition
								${item.isDone ? "bg-gradient-to-r from-yellow-100 to-yellow-300 border-yellow-400" : "bg-white border-slate-300"}`}
							>
								<div className="flex items-center gap-3">
									<div className="text-2xl">
										{missions[item.code]?.[item.level] ?? '❓'}
									</div>
									<div className="text-sm font-bold text-blue-900">
										{item.name}
									</div>
								</div>
								<div className="text-sm font-bold">
									{item.isDone ? "✓" : ""}
								</div>
							</div>
							))
						)}
				</div>
			</div>
			<div
				className="hidden md:block relative w-full min-h-[520px] h-[clamp(520px,70vh,680px)] rounded-[20px] border-[4px] border-blue-800 overflow-hidden shadow-inner"
				style={{
					background: `url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%221600%22%20height%3D%22900%22%20viewBox%3D%220%200%201600%20900%22%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3ClinearGradient%20id%3D%22sea%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220%22%20y2%3D%221%22%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%220%22%20stop-color%3D%22%237cc7ff%22/%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%232c7fd6%22/%3E%0A%20%20%20%20%3C/linearGradient%3E%0A%20%20%20%20%3Cfilter%20id%3D%22softShadow%22%20x%3D%22-20%25%22%20y%3D%22-20%25%22%20width%3D%22140%25%22%20height%3D%22140%25%22%3E%0A%20%20%20%20%20%20%3CfeDropShadow%20dx%3D%220%22%20dy%3D%228%22%20stdDeviation%3D%228%22%20flood-color%3D%22%2308315c%22%20flood-opacity%3D%220.25%22/%3E%0A%20%20%20%20%3C/filter%3E%0A%20%20%20%20%3Cfilter%20id%3D%22paper%22%20x%3D%22-10%25%22%20y%3D%22-10%25%22%20width%3D%22120%25%22%20height%3D%22120%25%22%3E%0A%20%20%20%20%20%20%3CfeTurbulence%20type%3D%22fractalNoise%22%20baseFrequency%3D%220.8%22%20numOctaves%3D%222%22%20seed%3D%222%22%20result%3D%22noise%22/%3E%0A%20%20%20%20%20%20%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%221%200%200%200%200%20%200%201%200%200%200%20%200%200%201%200%200%20%200%200%200%200.10%200%22%20in%3D%22noise%22%20result%3D%22n2%22/%3E%0A%20%20%20%20%20%20%3CfeBlend%20mode%3D%22multiply%22%20in%3D%22SourceGraphic%22%20in2%3D%22n2%22/%3E%0A%20%20%20%20%3C/filter%3E%0A%20%20%20%20%3ClinearGradient%20id%3D%22land%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%221%22%20y2%3D%221%22%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23f6e8c8%22/%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23e8d3a3%22/%3E%0A%20%20%20%20%3C/linearGradient%3E%0A%20%20%20%20%3ClinearGradient%20id%3D%22forest%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220%22%20y2%3D%221%22%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%220%22%20stop-color%3D%22%234fb06c%22/%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%232f7f4b%22/%3E%0A%20%20%20%20%3C/linearGradient%3E%0A%20%20%20%20%3ClinearGradient%20id%3D%22mount%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220%22%20y2%3D%221%22%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23b7c3d1%22/%3E%0A%20%20%20%20%20%20%3Cstop%20offset%3D%221%22%20stop-color%3D%22%236f7f93%22/%3E%0A%20%20%20%20%3C/linearGradient%3E%0A%20%20%20%20%3Cpattern%20id%3D%22wave%22%20width%3D%22120%22%20height%3D%2260%22%20patternUnits%3D%22userSpaceOnUse%22%3E%0A%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C30%20C20%2C10%2040%2C50%2060%2C30%20C80%2C10%20100%2C50%20120%2C30%22%20fill%3D%22none%22%20stroke%3D%22rgba%28255%2C255%2C255%2C0.18%29%22%20stroke-width%3D%223%22/%3E%0A%20%20%20%20%3C/pattern%3E%0A%20%20%20%20%3Cpattern%20id%3D%22speckle%22%20width%3D%2280%22%20height%3D%2280%22%20patternUnits%3D%22userSpaceOnUse%22%3E%0A%20%20%20%20%20%20%3Ccircle%20cx%3D%2210%22%20cy%3D%2212%22%20r%3D%221.2%22%20fill%3D%22rgba%280%2C0%2C0%2C0.05%29%22/%3E%0A%20%20%20%20%20%20%3Ccircle%20cx%3D%2240%22%20cy%3D%2222%22%20r%3D%221.0%22%20fill%3D%22rgba%280%2C0%2C0%2C0.04%29%22/%3E%0A%20%20%20%20%20%20%3Ccircle%20cx%3D%2265%22%20cy%3D%2250%22%20r%3D%221.4%22%20fill%3D%22rgba%280%2C0%2C0%2C0.05%29%22/%3E%0A%20%20%20%20%20%20%3Ccircle%20cx%3D%2225%22%20cy%3D%2262%22%20r%3D%221.1%22%20fill%3D%22rgba%280%2C0%2C0%2C0.04%29%22/%3E%0A%20%20%20%20%3C/pattern%3E%0A%20%20%3C/defs%3E%0A%0A%20%20%3C%21--%20Sea%20--%3E%0A%20%20%3Crect%20width%3D%221600%22%20height%3D%22900%22%20fill%3D%22url%28%23sea%29%22/%3E%0A%20%20%3Crect%20width%3D%221600%22%20height%3D%22900%22%20fill%3D%22url%28%23wave%29%22%20opacity%3D%220.65%22/%3E%0A%20%20%3Crect%20width%3D%221600%22%20height%3D%22900%22%20fill%3D%22url%28%23speckle%29%22%20opacity%3D%220.45%22/%3E%0A%0A%20%20%3C%21--%20Big%20continent%20--%3E%0A%20%20%3Cpath%20d%3D%22M110%2C190%0A%20%20%20%20%20%20%20%20%20%20%20C220%2C120%20360%2C120%20470%2C150%0A%20%20%20%20%20%20%20%20%20%20%20C650%2C200%20760%2C120%20920%2C125%0A%20%20%20%20%20%20%20%20%20%20%20C1110%2C130%201210%2C230%201270%2C310%0A%20%20%20%20%20%20%20%20%20%20%20C1360%2C430%201420%2C520%201450%2C610%0A%20%20%20%20%20%20%20%20%20%20%20C1485%2C715%201420%2C800%201310%2C820%0A%20%20%20%20%20%20%20%20%20%20%20C1080%2C860%20920%2C760%20780%2C780%0A%20%20%20%20%20%20%20%20%20%20%20C620%2C805%20470%2C870%20310%2C820%0A%20%20%20%20%20%20%20%20%20%20%20C180%2C780%2090%2C680%2080%2C560%0A%20%20%20%20%20%20%20%20%20%20%20C65%2C430%2020%2C260%20110%2C190Z%22%0A%20%20%20%20%20%20%20%20fill%3D%22url%28%23land%29%22%20filter%3D%22url%28%23softShadow%29%22/%3E%0A%20%20%3C%21--%20Coast%20highlight%20--%3E%0A%20%20%3Cpath%20d%3D%22M120%2C205%0A%20%20%20%20%20%20%20%20%20%20%20C230%2C138%20360%2C140%20465%2C168%0A%20%20%20%20%20%20%20%20%20%20%20C650%2C218%20760%2C150%20920%2C150%0A%20%20%20%20%20%20%20%20%20%20%20C1105%2C150%201200%2C245%201255%2C318%0A%20%20%20%20%20%20%20%20%20%20%20C1340%2C430%201395%2C520%201425%2C602%0A%20%20%20%20%20%20%20%20%20%20%20C1460%2C700%201405%2C770%201300%2C790%0A%20%20%20%20%20%20%20%20%20%20%20C1090%2C830%20935%2C740%20790%2C755%0A%20%20%20%20%20%20%20%20%20%20%20C630%2C780%20480%2C845%20320%2C800%0A%20%20%20%20%20%20%20%20%20%20%20C200%2C765%20115%2C675%20108%2C565%0A%20%20%20%20%20%20%20%20%20%20%20C92%2C440%2045%2C270%20120%2C205Z%22%0A%20%20%20%20%20%20%20%20fill%3D%22none%22%20stroke%3D%22rgba%28255%2C255%2C255%2C0.35%29%22%20stroke-width%3D%226%22/%3E%0A%0A%20%20%3C%21--%20Eastern%20islands%20--%3E%0A%20%20%3Cpath%20d%3D%22M1370%2C160%20C1435%2C110%201525%2C120%201550%2C180%0A%20%20%20%20%20%20%20%20%20%20%20C1575%2C245%201505%2C290%201425%2C270%0A%20%20%20%20%20%20%20%20%20%20%20C1360%2C255%201335%2C205%201370%2C160Z%22%0A%20%20%20%20%20%20%20%20fill%3D%22url%28%23land%29%22%20filter%3D%22url%28%23softShadow%29%22/%3E%0A%20%20%3Cpath%20d%3D%22M1240%2C120%20C1275%2C95%201320%2C105%201335%2C140%0A%20%20%20%20%20%20%20%20%20%20%20C1355%2C190%201290%2C210%201255%2C190%0A%20%20%20%20%20%20%20%20%20%20%20C1220%2C170%201210%2C145%201240%2C120Z%22%0A%20%20%20%20%20%20%20%20fill%3D%22url%28%23land%29%22%20opacity%3D%220.95%22%20filter%3D%22url%28%23softShadow%29%22/%3E%0A%0A%20%20%3C%21--%20Rivers%20--%3E%0A%20%20%3Cpath%20d%3D%22M980%2C200%20C950%2C250%20930%2C320%20920%2C390%0A%20%20%20%20%20%20%20%20%20%20%20C910%2C470%20860%2C540%20810%2C610%0A%20%20%20%20%20%20%20%20%20%20%20C760%2C680%20730%2C740%20720%2C790%22%0A%20%20%20%20%20%20%20%20fill%3D%22none%22%20stroke%3D%22rgba%2864%2C170%2C255%2C0.65%29%22%20stroke-width%3D%2210%22%20stroke-linecap%3D%22round%22/%3E%0A%20%20%3Cpath%20d%3D%22M1030%2C240%20C1080%2C260%201120%2C310%201130%2C360%0A%20%20%20%20%20%20%20%20%20%20%20C1140%2C420%201110%2C480%201070%2C530%22%0A%20%20%20%20%20%20%20%20fill%3D%22none%22%20stroke%3D%22rgba%2864%2C170%2C255%2C0.55%29%22%20stroke-width%3D%228%22%20stroke-linecap%3D%22round%22/%3E%0A%0A%20%20%3C%21--%20Roads%20%28dotted%29%20--%3E%0A%20%20%3Cpath%20d%3D%22M260%2C520%20C420%2C440%20560%2C460%20700%2C520%0A%20%20%20%20%20%20%20%20%20%20%20C840%2C580%20980%2C560%201120%2C480%0A%20%20%20%20%20%20%20%20%20%20%20C1230%2C420%201330%2C430%201410%2C520%22%0A%20%20%20%20%20%20%20%20fill%3D%22none%22%20stroke%3D%22rgba%28110%2C80%2C40%2C0.65%29%22%20stroke-width%3D%228%22%20stroke-linecap%3D%22round%22%20stroke-dasharray%3D%226%2014%22/%3E%0A%20%20%3Cpath%20d%3D%22M360%2C250%20C480%2C290%20560%2C360%20590%2C450%0A%20%20%20%20%20%20%20%20%20%20%20C620%2C540%20700%2C610%20820%2C660%22%0A%20%20%20%20%20%20%20%20fill%3D%22none%22%20stroke%3D%22rgba%28110%2C80%2C40%2C0.55%29%22%20stroke-width%3D%227%22%20stroke-linecap%3D%22round%22%20stroke-dasharray%3D%226%2014%22/%3E%0A%0A%20%20%3C%21--%20Mountain%20ranges%20--%3E%0A%20%20%3Cg%20opacity%3D%220.95%22%20filter%3D%22url%28%23softShadow%29%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M650%2C260%20L720%2C140%20L790%2C260%20Z%22%20fill%3D%22url%28%23mount%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M735%2C270%20L810%2C155%20L890%2C270%20Z%22%20fill%3D%22url%28%23mount%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M820%2C285%20L900%2C175%20L980%2C285%20Z%22%20fill%3D%22url%28%23mount%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M720%2C215%20L760%2C165%20L800%2C215%20Z%22%20fill%3D%22rgba%28255%2C255%2C255%2C0.45%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M810%2C230%20L850%2C175%20L890%2C230%20Z%22%20fill%3D%22rgba%28255%2C255%2C255%2C0.45%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M900%2C245%20L940%2C190%20L980%2C245%20Z%22%20fill%3D%22rgba%28255%2C255%2C255%2C0.45%29%22/%3E%0A%20%20%3C/g%3E%0A%0A%20%20%3C%21--%20Forest%20blobs%20--%3E%0A%20%20%3Cg%20opacity%3D%220.95%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M250%2C360%20C260%2C320%20320%2C300%20370%2C320%0A%20%20%20%20%20%20%20%20%20%20%20%20%20C420%2C340%20450%2C380%20430%2C425%0A%20%20%20%20%20%20%20%20%20%20%20%20%20C405%2C480%20330%2C500%20280%2C470%0A%20%20%20%20%20%20%20%20%20%20%20%20%20C240%2C445%20230%2C405%20250%2C360Z%22%0A%20%20%20%20%20%20%20%20%20%20fill%3D%22url%28%23forest%29%22%20filter%3D%22url%28%23softShadow%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M1050%2C560%20C1070%2C520%201125%2C505%201170%2C520%0A%20%20%20%20%20%20%20%20%20%20%20%20%20C1220%2C540%201245%2C585%201220%2C625%0A%20%20%20%20%20%20%20%20%20%20%20%20%20C1195%2C670%201125%2C680%201075%2C655%0A%20%20%20%20%20%20%20%20%20%20%20%20%20C1035%2C635%201025%2C600%201050%2C560Z%22%0A%20%20%20%20%20%20%20%20%20%20fill%3D%22url%28%23forest%29%22%20filter%3D%22url%28%23softShadow%29%22/%3E%0A%20%20%3C/g%3E%0A%0A%20%20%3C%21--%20Lakes%20--%3E%0A%20%20%3Cellipse%20cx%3D%22320%22%20cy%3D%22640%22%20rx%3D%2290%22%20ry%3D%2255%22%20fill%3D%22rgba%2890%2C200%2C255%2C0.55%29%22%20stroke%3D%22rgba%28255%2C255%2C255%2C0.35%29%22%20stroke-width%3D%226%22/%3E%0A%20%20%3Cellipse%20cx%3D%221180%22%20cy%3D%22320%22%20rx%3D%2270%22%20ry%3D%2245%22%20fill%3D%22rgba%2890%2C200%2C255%2C0.50%29%22%20stroke%3D%22rgba%28255%2C255%2C255%2C0.35%29%22%20stroke-width%3D%226%22/%3E%0A%0A%20%20%3C%21--%20Decorative%20compass%20--%3E%0A%20%20%3Cg%20transform%3D%22translate%281420%20120%29%22%20opacity%3D%220.85%22%3E%0A%20%20%20%20%3Ccircle%20cx%3D%220%22%20cy%3D%220%22%20r%3D%2248%22%20fill%3D%22rgba%28255%2C255%2C255%2C0.55%29%22%20stroke%3D%22rgba%2820%2C40%2C80%2C0.45%29%22%20stroke-width%3D%224%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%2C-42%20L10%2C-8%20L0%2C0%20L-10%2C-8%20Z%22%20fill%3D%22rgba%2820%2C40%2C80%2C0.65%29%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%2C42%20L10%2C8%20L0%2C0%20L-10%2C8%20Z%22%20fill%3D%22rgba%28200%2C70%2C70%2C0.65%29%22/%3E%0A%20%20%20%20%3Ctext%20x%3D%220%22%20y%3D%22-58%22%20text-anchor%3D%22middle%22%20font-family%3D%22system-ui%2C%20sans-serif%22%20font-size%3D%2218%22%20fill%3D%22rgba%2820%2C40%2C80%2C0.7%29%22%3EN%3C/text%3E%0A%20%20%3C/g%3E%0A%0A%20%20%3C%21--%20Soft%20vignette%20--%3E%0A%20%20%3Crect%20width%3D%221600%22%20height%3D%22900%22%20fill%3D%22rgba%280%2C0%2C0%2C0.08%29%22/%3E%0A%3C/svg%3E") center/cover no-repeat`
				}}
			>
				<div className="absolute inset-0 bg-white/10 pointer-events-none" />
				<div className="absolute top-[8%] right-[12%] text-[32px] opacity-40 z-[1] drop-shadow">☁️</div>
				<div className="absolute top-[25%] left-[8%] text-[26px] opacity-35 z-[1] drop-shadow">☁️</div>
				<div className="absolute bottom-[18%] right-[22%] text-[30px] opacity-40 z-[1] drop-shadow">☁️</div>
				<div className="absolute top-[48%] left-[45%] text-[24px] opacity-30 z-[1] drop-shadow">☁️</div>
				<div className="absolute bottom-[35%] left-[28%] text-[22px] opacity-35 z-[1] drop-shadow">☁️</div>
				<div className="absolute inset-0 w-full h-full z-10">
					{filteredItems?.map((item) => (
						<div
							key={item.id}
							onClick={() => handleClick(item.code, item.level)}
							className={`absolute cursor-pointer transition-all duration-300
								${item.isDone ? 'z-[20]' : 'z-[15] group'}
							`}
							style={{top: missions[item.code]?.position?.top, left: missions[item.code]?.position?.left, transform: 'translate(-50%, -50%)'}}
						>
							<div className={`relative w-[90px] h-[90px] rounded-[12px] p-2 flex flex-col items-center justify-center backdrop-blur transition-all duration-300 hover:scale-125 hover:-translate-y-[5px] hover:shadow-[0_12px_30px_rgba(0,0,0,0.35)]
					    		${item.isDone ? 'bg-gradient-to-br from-yellow-200 to-yellow-400 border-[3px] border-amber-500 shadow-[0_8px_20px_rgba(0,0,0,0.25)]'
					    			 : 'bg-white/95 border-[3px] border-slate-500 shadow-[0_8px_20px_rgba(0,0,0,0.25)]'}
								`}
							>
    							{item.isDone && (
				 					<div className="absolute -top-[10px] -right-[10px] w-[32px] h-[32px] bg-gradient-to-br from-emerald-500 to-emerald-700 border-[3px] border-white rounded-full flex items-center justify-center text-white font-bold text-[16px] shadow-[0_4px_12px_rgba(16,185,129,0.5)] rotate-[15deg] animate-bounce">✓</div>
								)}
			                    <div className="text-[28px] mb-1 drop-shadow">{missions[item.code]?.[item.level] ?? '❓'}</div>
			                    <div className="text-[10px] font-bold text-center text-blue-900 leading-[1.3]">{item.name}</div>
			                </div>
						</div>
					))}
				</div>
				<div className="absolute bottom-5 left-5 bg-white/95 p-3 rounded-[10px] border-2 border-blue-800 shadow-lg z-20 backdrop-blur">
					<div className="text-[11px] font-bold mb-2 text-blue-800">범례</div>
					<label className="flex items-center gap-2 text-[10px] mb-1 cursor-pointer">
						<input
							type="radio"
							name="exploreStatus"
							value="all"
							checked={exploreStatus === "all"}
							onChange={() => setExploreStatus("all")}
							className="hidden"
						/>
						<div
							className={`w-5 h-5 border-2 rounded flex items-center justify-center text-xs
							${
								exploreStatus === "all"
								? "bg-gradient-to-br from-yellow-100 to-yellow-400 border-yellow-500"
								: "bg-white border-slate-400"
							}`}
						>
							{exploreStatus === "all" && "✓"}
						</div>
						<span>전체</span>
					</label>
					<label className="flex items-center gap-2 text-[10px] mb-1 cursor-pointer">
						<input
							type="radio"
							name="exploreStatus"
							value="not_done"
							checked={exploreStatus === "not_done"}
							onChange={() => setExploreStatus("not_done")}
							className="hidden"
						/>
						<div
							className={`w-5 h-5 border-2 rounded flex items-center justify-center text-xs
							${
								exploreStatus === "not_done"
								? "bg-gradient-to-br from-yellow-100 to-yellow-400 border-yellow-500"
								: "bg-white border-slate-400"
							}`}
						>
							{exploreStatus === "not_done" && "✓"}
						</div>
						<span>미탐험</span>
					</label>
					<label className="flex items-center gap-2 text-[10px] cursor-pointer">
						<input
							type="radio"
							name="exploreStatus"
							value="done"
							checked={exploreStatus === "done"}
							onChange={() => setExploreStatus("done")}
							className="hidden"
						/>
						<div
							className={`w-5 h-5 border-2 rounded flex items-center justify-center text-xs
							${
								exploreStatus === "done"
								? "bg-gradient-to-br from-yellow-100 to-yellow-400 border-yellow-500"
								: "bg-white border-slate-400"
							}`}
						>
							{exploreStatus === "done" && "✓"}
						</div>
						<span>탐험완료</span>
					</label>
				</div>
				<div className="absolute top-5 right-5 bg-white/95 p-3 rounded-[10px] border-2 border-blue-800 shadow-lg z-20 backdrop-blur">
					<div className="text-[11px] font-bold text-blue-800 mb-1">탐험 현황</div>
					<div className="text-[10px] text-slate-500">
						<span className="text-slate-500">완료: </span>
						<span className="font-bold text-green-500">{items?.filter(item => item.isDone).length} </span>
						<span className="text-slate-500">/ {data?.data?.pagination?.total_count}</span>
					</div>
					<div className="text-[10px] text-slate-500">
						<span className="text-slate-500">레벨: </span>
						<span className="font-bold text-blue-500">{explore?.level}</span>
					</div>
				</div>
			</div>
			<div className="text-center mt-4 text-sm text-white md:text-gray-600">각 나라를 클릭하면 해당 페이지로 이동합니다!</div>
		</div>
  	);
};

export default WorldMapPage;